import { useState, useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';

/** @param value - the raw value to throttle @param delay - minimum ms between updates */
export const useThrottle = <T>(value: T, delay: number): T => {
  const [throttledValue, setThrottledValue] = useState(value);

  const throttled = useRef(throttle((v: T) => setThrottledValue(v), delay));

  useEffect(() => {
    throttled.current(value);
  }, [value]);

  return throttledValue;
};
